import MobilityMap, { mapTypes } from "./MobilityMap";

export { mapTypes };
export default MobilityMap;